<template>
  <div :class="['toaster', type]">
    <span class="message">
      {{ message }}
    </span>
    <span class="close-button" @click="emit('close')">
      <UiIcon
        :is-clickable="true"
        name="close"
        color-fill="var(--color-base-white)"
        size="16px"
      />
    </span>
  </div>
</template>

<script lang="ts" setup>
import UiIcon from '@sephora-asia/ui-icon/UiIcon.vue'
import type { ToasterProps } from './types'

interface Emits {
  (e: 'close'): void
}

const props = defineProps<ToasterProps>()
const emit = defineEmits<Emits>()
</script>

<style lang="scss" scoped>
.toaster {
  @extend .headline-m;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;

  .message {
    width: 100%;
    text-align: center;
    padding: 0.75rem 1rem;
  }

  .close-button {
    display: flex;
    padding: 0.75rem 1rem;
    cursor: pointer;
  }

  &.success {
    background-color: var(--color-base-green-n100);
    color: var(--color-base-white);
  }

  &.error {
    background-color: var(--color-base-red-n100);
    color: var(--color-base-white);
  }

  &.info {
    background-color: var(--color-base-blue-n100);
    color: var(--color-base-white);
  }
}
</style>
